import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../../redux/slice/authSlice';
import { getWebhookUrl, updateWebhookUrl } from '../../../api/adminApi/adminApi';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom';

const WebhookUrl = ({ open, handleClose, initialUrl }) => {

  const { id } = useSelector(selectAuth);
  const [ loading, setLoading ] = useOutletContext();
  
  // Formik validation schema
  const validationSchema = Yup.object({
    webhookUrl: Yup.string().url('Invalid URL').required('Webhook URL is required'),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      webhookUrl: initialUrl || '', // Set initial URL value or empty string
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
   //   console.log('Dialog Input:', values.webhookUrl); // Handle form data here
      updateDoctorUrl(values.webhookUrl); // You can call the API function here
      handleClose(); // Close the dialog after submission
    },
  });

  const updateDoctorUrl = async(url) => {
    // Function to handle the update, e.g., calling an API
    setLoading(true);
    let data = { id, url };
    let response = await updateWebhookUrl(data);
    setLoading(false);
    toast.success(response.data.message);
  };

  useEffect(() => {
    // Handle any necessary effects
    const getUrl = async()=>{
        let response = await getWebhookUrl(id);
        formik.setFieldValue('webhookUrl', response.data.data.url);
    }
    getUrl();
  }, []);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        Webhook URL Details
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            label="Webhook URL"
            name="webhookUrl"
            value={formik.values.webhookUrl}
            onChange={formik.handleChange}
            error={formik.touched.webhookUrl && Boolean(formik.errors.webhookUrl)}
            helperText={formik.touched.webhookUrl && formik.errors.webhookUrl}
            margin="normal"
          />
        </form>
      </DialogContent>
      <DialogActions>
        <button type='button' className='btn btn-blacked outline me-2' onClick={handleClose}>
          Cancel
        </button>
        <button type='submit' className='btn btn-blacked' onClick={formik.handleSubmit}>
          Submit
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default WebhookUrl;
